import { useSelector } from 'react-redux';
import { PermissionService } from '../PermissionService';
import { useMemo } from 'react';
import { accountPK_PermissionRoleSelector } from 'helpers/selectors/users';

/**
 * Custom React hook to check if the currently logged-in user has the specified permission.
 *
 * Uses the current user's role (via Redux selector) and PermissionService to determine access rights.
 * Returns a boolean indicating whether the user has the given permission key.
 *
 * @param {string} permissionKey - The permission key to check (from {@link PERMISSIONS}).
 * @returns {boolean} True if the current user has the permission, false otherwise.
 *
 * @example
 * const canEdit = usePermission(PERMISSIONS.MANAGE_USERS);
 * if (canEdit) {
 *   // Render edit button
 * }
 */
export const usePermission = (permissionKey) => {
    const role = useSelector(accountPK_PermissionRoleSelector);

    return useMemo(() => PermissionService.hasPermission(role, permissionKey), [role, permissionKey]);
};
